module.exports = __webpack_public_path__ + "c7800828f04686b2d7ea6e6e31440697.svg";